import { Component, ViewEncapsulation } from '@angular/core';
import { MatSnackBarRef } from '@angular/material/snack-bar';
import { MatButtonModule } from '@angular/material/button';
import { TranslateModule } from '@ngx-translate/core';

@Component({
	selector: 'copo-snackbar-cancel-issue',
	templateUrl: './snackbar-cancel-issue.component.html',
	encapsulation: ViewEncapsulation.Emulated,

	imports: [TranslateModule, MatButtonModule]
})
export class SnackbarCancelIssueComponent {
	constructor(
		private readonly snackBarRef: MatSnackBarRef<SnackbarCancelIssueComponent>
	) {}

	dismiss() {
		this.snackBarRef.dismiss();
	}
}
